module.exports = __webpack_public_path__ + "img/gala-film-logo.61baabe.svg";